document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var toggle = document.querySelector('.site-header__mobile-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('site-nav--open');
    });
  }

  // Product gallery thumbnail swap
  var thumbs = document.querySelectorAll('.product-detail__thumb');
  var mainImage = document.getElementById('ProductMainImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-image-url');
      if (mainImage && url) {
        mainImage.src = url;
      }
      thumbs.forEach(function (t) { t.classList.remove('product-detail__thumb--active'); });
      thumb.classList.add('product-detail__thumb--active');
    });
  });

  // Product info tabs
  var tabButtons = document.querySelectorAll('.tabs__tab');
  var tabPanels = document.querySelectorAll('.tabs__panel');
  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab');
      tabButtons.forEach(function (b) { b.classList.remove('tabs__tab--active'); });
      tabPanels.forEach(function (p) { p.classList.remove('tabs__panel--active'); });
      btn.classList.add('tabs__tab--active');
      var panel = document.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) panel.classList.add('tabs__panel--active');
    });
  });

  // Quantity stepper (product page + cart)
  document.querySelectorAll('[data-qty-decrease], [data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || 0;
      if (btn.hasAttribute('data-qty-decrease')) {
        input.value = Math.max(min, value - 1);
      } else {
        input.value = value + 1;
      }
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  // --- Money formatting (mirrors Shopify's money_format string, all placeholder variants) ---
  function formatMoney(cents, format) {
    format = format || window.themeMoneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(value, fallback) {
      return value == null || value !== value ? fallback : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) number = 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';

      return dollars + cents2;
    }

    var value = '';
    var match = format.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  // --- Live-update Add to Cart button price and sticky bar price as quantity changes ---
  var qtyInput = document.getElementById('Quantity');
  var submitBtnForPrice = document.getElementById('ProductSubmitButton');
  var submitPriceEl = document.getElementById('ProductSubmitPrice');
  var stickyPriceEl = document.getElementById('StickyPrice');

  function updateQuantityPrice() {
    if (!qtyInput) return;
    var qty = parseInt(qtyInput.value, 10) || 1;
    if (submitBtnForPrice && submitPriceEl) {
      var unitPrice = parseInt(submitBtnForPrice.getAttribute('data-unit-price'), 10) || 0;
      submitPriceEl.textContent = formatMoney(unitPrice * qty);
    }
    if (stickyPriceEl) {
      var unitPriceSticky = parseInt(stickyPriceEl.getAttribute('data-unit-price'), 10) || 0;
      stickyPriceEl.textContent = formatMoney(unitPriceSticky * qty);
    }
  }

  if (qtyInput) {
    qtyInput.addEventListener('input', updateQuantityPrice);
  }

  // --- Cart: auto-update on quantity change (no "Update cart" click needed) ---
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    var debounceTimers = {};

    function updateLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart update failed');
          return r.json();
        })
        .then(function (cart) {
          // Update header cart count
          document.querySelectorAll('.site-header__cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });

          // Update subtotal + item count label
          var subtotalEl = document.querySelector('[data-cart-subtotal]');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          var countLabel = document.querySelector('[data-cart-item-count-label]');
          if (countLabel) {
            countLabel.textContent = 'Subtotal · ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
          }

          if (quantity === 0) {
            var row = document.querySelector('[data-cart-row="' + key + '"]');
            if (row) row.remove();
            if (cart.item_count === 0) {
              window.location.reload();
              return;
            }
          } else {
            var lineItem = cart.items.filter(function (i) { return i.key === key; })[0];
            if (lineItem) {
              var lineTotalEl = document.querySelector('[data-cart-line-total="' + key + '"]');
              if (lineTotalEl) lineTotalEl.textContent = formatMoney(lineItem.final_line_price);
            }
          }
        })
        .catch(function () {
          // Fallback: normal form submit still works if AJAX fails
          cartForm.submit();
        });
    }

    document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
      var key = input.getAttribute('data-cart-qty-input');
      input.addEventListener('input', function () {
        clearTimeout(debounceTimers[key]);
        debounceTimers[key] = setTimeout(function () {
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          updateLine(key, qty);
        }, 500);
      });
    });

    // Remove buttons now update instantly via AJAX instead of full form submit
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-cart-remove');
        var input = document.querySelector('[data-cart-qty-input="' + key + '"]');
        if (input) input.value = 0;
        updateLine(key, 0);
      });
    });

    // "Update cart" link is a no-JS fallback; hide it once auto-update is active
    var fallbackBtn = document.querySelector('[data-cart-update-fallback]');
    if (fallbackBtn) fallbackBtn.style.display = 'none';
  }

  // Sticky add-to-cart bar (mobile): show once the main button scrolls out of view
  var stickyBar = document.getElementById('StickyAddToCart');
  var mainSubmitBtn = document.getElementById('ProductSubmitButton');
  if (stickyBar && mainSubmitBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('sticky-add-to-cart--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainSubmitBtn);

    var stickyBtn = document.getElementById('StickyAddToCartBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = mainSubmitBtn.closest('form');
        if (form && form.requestSubmit) {
          form.requestSubmit(mainSubmitBtn);
        } else {
          mainSubmitBtn.click();
        }
      });
    }
  }

  // AJAX add-to-cart with cart count update (progressive enhancement;
  // falls back to normal form submit if fetch fails)
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn && submitBtn.hasAttribute('disabled')) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var countEls = document.querySelectorAll('.site-header__cart-count');
          countEls.forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (submitBtn) {
            var originalHTML = submitBtn.innerHTML;
            submitBtn.textContent = 'Added!';
            setTimeout(function () {
              submitBtn.innerHTML = originalHTML;
            }, 1500);
          }
        })
        .catch(function () {
          // Fallback: submit the form normally so the customer still completes the action
          form.submit();
        });
    });
  });
});
